import { render } from "./AyudaReferencia.vue?vue&type=template&id=b7a3b6f8&scoped=true"
import script from "./AyudaReferencia.vue?vue&type=script&lang=js"
export * from "./AyudaReferencia.vue?vue&type=script&lang=js"

import "@/assets/css/ayuda.css?vue&type=style&index=0&id=b7a3b6f8&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7a3b6f8"]])

export default __exports__